import { createSelector } from 'reselect';
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
import { SEARCH_TYPES } from '../utils/constants';

const searchTypesList = [
  {
    type: SEARCH_TYPES.STUDENT,
    label: capitalize(SEARCH_TYPES.STUDENT),
    icon: 'person_group',
  },
  {
    type: SEARCH_TYPES.ASSIGNMENTS,
    label: capitalize(SEARCH_TYPES.ASSIGNMENTS),
    icon: 'blank_document',
  },
];

const courseIdSelectorFunction = (state) =>
  get(state, 'gradebook.courseId', null);
const isSectionManagerFunction = (_state, props) => {
  get(props, 'isSectionManager', false);
};
const searchPhraseSelectorFunction = (state) => state.gradebook.searchPhrase;
const searchTypeSelectorFunction = (state) => state.gradebook.searchType;
const searchTypeMenuOpenSelectorFunction = (state) =>
  state.gradebook.searchTypeMenuOpen;
const searchTypeMenuAnchorElSelectorFunction = (state) =>
  state.gradebook.searchTypeMenuAnchorEl;
const exceptionGroupsSelectorFunction = (state) =>
  state.gradebook.exceptionGroups;
const filterTypesSelectorFunction = (state) => state.gradebook.filterTypes;
const visibleFilterSectionFunction = (state) =>
  state.gradebook.visibleFilterSection;
const searchDateFromFunction = (state) => state.gradebook.searchDateFrom;
const searchDateToFunction = (state) => state.gradebook.searchDateTo;
const isGradebookV2ActiveFunction = (state) =>
  state.gradebook.isGradebookV2Active;
export const getGradebookStudents = (state) => state.gradebook.students;

export const courseIdSelector = createSelector(
  courseIdSelectorFunction,
  (courseId) => courseId,
);
export const searchPhraseSelector = createSelector(
  searchPhraseSelectorFunction,
  (searchPhrase) => searchPhrase,
);
export const searchTypeMenuOpenSelector = createSelector(
  searchTypeMenuOpenSelectorFunction,
  (searchTypeMenuOpen) => searchTypeMenuOpen,
);
export const searchTypeMenuAnchorElSelector = createSelector(
  searchTypeMenuAnchorElSelectorFunction,
  (searchTypeMenuAnchorEl) => searchTypeMenuAnchorEl,
);
export const exceptionGroupsSelector = createSelector(
  exceptionGroupsSelectorFunction,
  (exceptionGroups) => exceptionGroups,
);
export const filterTypesSelector = createSelector(
  filterTypesSelectorFunction,
  (filterTypes) => filterTypes,
);
export const visibleFilterSelector = createSelector(
  visibleFilterSectionFunction,
  (visibleFilterSection) => visibleFilterSection,
);
export const searchDateFromSelector = createSelector(
  searchDateFromFunction,
  (searchDateFrom) => searchDateFrom,
);
export const searchDateToSelector = createSelector(
  searchDateToFunction,
  (searchDateTo) => searchDateTo,
);

export const searchTypeSelector = createSelector(
  [isSectionManagerFunction, searchTypeSelectorFunction],
  (isSectionManager, searchType) => {
    if (searchType) {
      return searchType;
    }
    if (isSectionManager) {
      return SEARCH_TYPES.ASSIGNMENTS;
    }
    return SEARCH_TYPES.STUDENT;
  },
);

export const availableSearchTypesSelector = createSelector(
  [isSectionManagerFunction, getGradebookStudents],
  (isSectionManager, students) => {
    if (isSectionManager) {
      return searchTypesList.filter(
        (searchType) => searchType.type === SEARCH_TYPES.ASSIGNMENTS,
      );
    }
    if (students.length <= 0) {
      return searchTypesList.filter(
        (searchType) => searchType.type !== SEARCH_TYPES.STUDENT,
      );
    }
    return searchTypesList;
  },
);

export const exceptionGroupsStudentIdsSelector = createSelector(
  [exceptionGroupsSelectorFunction],
  (exceptionGroups) => {
    return exceptionGroups.reduce((studentIds, exceptionGroup) => {
      return [...studentIds, ...exceptionGroup.studentIds];
    }, []);
  },
);

export const isGradebookV2ActiveSelector = createSelector(
  isGradebookV2ActiveFunction,
  (isGradebookV2Active) => isGradebookV2Active,
);
